import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, autoResize = false, maxHeight = 360, onChange, style, ...props }, ref) => {
  const innerRef = React.useRef(null)

  React.useImperativeHandle(ref, () => innerRef.current)

  const resizeTextarea = React.useCallback(() => {
    if (!autoResize || !innerRef.current) return
    innerRef.current.style.height = "auto"
    const nextHeight = Math.min(innerRef.current.scrollHeight, maxHeight)
    innerRef.current.style.height = `${nextHeight}px`
    innerRef.current.style.overflowY = innerRef.current.scrollHeight > maxHeight ? "auto" : "hidden"
  }, [autoResize, maxHeight])

  React.useEffect(() => {
    resizeTextarea()
  }, [resizeTextarea, props.value])

  const handleChange = (event) => {
    if (autoResize) {
      resizeTextarea()
    }
    onChange?.(event)
  }

  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={innerRef}
      onChange={handleChange}
      style={style}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
